import script from "./UpdateVariantProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateVariantProduct.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateVariantProduct.vue?vue&type=style&index=0&id=4294a6c7&lang=scss"

const __exports__ = script;

export default __exports__